import { createStackNavigator } from '@react-navigation/stack';
import { BookingNavigationParamList } from './BookingStackNavigator';

const { Navigator, Screen } = createStackNavigator<BookingNavigationParamList>();

export { Navigator, Screen };
